import {Component, Input} from '@angular/core';
import {FolderComponentObject} from '../../../shared/classes/folder-component-object';
import {Store} from '@ngrx/store';
import {AppState} from '../../../shared/store/store';
import {dialogOpen} from '../../../shared/store/dialog/dialog.actions';
import {FolderFormComponent} from '../folder-form/folder-form.component';

@Component({
  selector: 'app-edit-folder-button',
  templateUrl: './edit-folder-button.component.html',
  styleUrls: ['./edit-folder-button.component.scss']
})
export class EditFolderButtonComponent {
  @Input() folder: FolderComponentObject;
  @Input() disabled: boolean;

  constructor(
    private readonly _store: Store<AppState>
  ) {
  }

  public edit(): void {
    this._store.dispatch(dialogOpen({
      component: FolderFormComponent,
      config: {
        width: '500px',
        height: 'auto',
        disableClose: true
      },
      data: {
        folder: this.folder
      }
    }));
  }

}
